export const defaultTaxInformationState = () => ({
  taxInformation: {
    nfeModel: null,
    nfeNumber: null,
    nfeKey: null,
    buyer: null,
    buyerId: null,
    natureza: {
      error: false,
      cfop: {
        id: null,
        codigo: null,
        descricao: null,
      },
    },
    issueDate: null,
    entryDate: null,
  },
});

const defaultLinkedDocumentsState = () => ({
  linkedDocuments: {
    linkedDocumentCollection: [],
  },
});

const defaultSupplierState = () => ({
  supplierInformation: {
    supplier: {
      supplierId: null,
      id: null,
      error: false,
      uuid: '',
      name: '',
      exportationDoc: '',
      businessName: '',
      identification: '',
      identificationFormatted: '',
      label: '',
      accountantCPF: null,
      CRC: null,
      stateCode: '',
      suframaCode: null,
      cityCode: null,
      site: null,
      image: null,
      rg: '',
      indicadorIE: null,
      contactPerson: '',
      observation: null,
      alert: null,
      active: null,
      creditLimit: null,
      isAccountant: null,
      isClient: null,
      isSupplier: null,
      isDelivery: null,
      isRural: null,
      remoteId: null,
      personType: null,
      balanceLimit: null,
      created: '',
      emailCollection: [],
      phone: {
        countryCode: null,
        areaCode: null,
        number: '',
        type: null,
        id: null,
      },
      address: {
        identification: null,
        number: '',
        complement: '',
        street: '',
        neighbourhood: '',
        type: null,
        isForeign: null,
        id: null,
        zipCode: {
          id: null,
          street: '',
          neighbourhood: '',
          zipCode: '',
          city: {
            id: null,
            name: '',
            code: '',
            state: {
              id: null,
              name: '',
              acronym: '',
              code: null,
              country: {
                name: '',
                acronym: '',
                fiscalId: '',
                id: null,
              },
            },
          },
        },
      },
      creditLimitBalance: null,
      overdueDaysAvg: null,
      firstBuyDate: null,
      lastBuyDate: null,
      activity: {
        id: null,
        name: '',
      },
    },
  },
});

const defaultProductsState = () => ({
  products: {
    productOfPurchaseCollection: [],
    quantityPurchased: 1,
  },
});

const defaultTaxCalcState = () => ({
  taxCalc: {
    calcTypes: [],
    purchaseId: null,
    vProd: 0,
    vBC: 0,
    vBCST: 0,
    vCOFINS: 0,
    vICMS: 0,
    vICMSDeson: 0,
    vIPI: 0,
    vPIS: 0,
    vICMSST: 0,
    vFCP: 0,
    vFCPST: 0,
    vFCPSTRet: 0,
    vDesc: 0,
    vFrete: 0,
    vSeg: 0,
    vTotTrib: 0,
    vOutro: 0,
    vNF: 0,
  },
});

const defaultPaymentsState = () => ({
  payments: {
    payment: {
      id: null,
      name: null,
      value: 0,
      category: null,
      account: null,
      range: [],
    },
    range: [],
    remainder: 0,
    accountCollectionData: [],
    categoryCollectionData: [],
    paymentModeCollection: [],
  },
});

const defaultProductOfPurchaseOnFiscalEditState = () => ({
  productOfPurchaseOnFiscalEdit: {
    edited: false,
    isImportation: false,
    originalIndex: null,
    productData: {
      price: null,
      quantityPurchased: null,
      discount: 0,
      totalPrice: null,
      unitOfMeasure: {},
    },
    fiscal: {
      values: {
        id: null,
        modBC: null,
        modBCST: null,
        motDesICMS: null,
        orig: null,
        pDif: 0,
        pICMS: 0,
        pICMSST: 0,
        pMVAST: 0,
        pRedBC: 0,
        pRedBCST: 0,
        vBC: 0,
        vBCST: 0,
        vBCSTRet: 0,
        vICMS: 0,
        vICMSDeson: 0,
        vICMSDif: 0,
        vICMSOp: 0,
        vICMSST: 0,
        vICMSSTRet: 0,
        pST: 0,
        pRedBCEfet: 0,
        vBCEfet: 0,
        pICMSEfet: 0,
        vICMSEfet: 0,
        vBCSTDest: 0,
        vICMSSTDest: 0,
        vFCP: 0,
        vBCFCP: 0,
        pFCP: 0,
        vFCPST: 0,
        vBCFCPST: 0,
        pFCPST: 0,
        vFCPSTRet: 0,
        vIPI: 0,
        vBCIPI: 0,
        pIPI: 0,
        vPIS: 0,
        vBCPIS: 0,
        pPIS: 0,
        vCOFINS: 0,
        vBCCOFINS: 0,
        pCOFINS: 0,
        cfop: null,
        csosn: null,
        origem: null,
        cst: null,
        cenq: null,
        cstIpi: null,
        cstPis: null,
        cstCofins: null,
        observation: null,
      },
      ids: {
        id: null,
        ncmId: null,
        cenqId: null,
        cestId: null,
        origemId: null,
        cstId: null,
        cfopId: null,
        anpId: null,
        csosnId: null,
        cstIPIId: null,
        cstPISId: null,
        cstCOFINSId: null,
      },
    },
  },
});

const defaultImportedInvoiceState = () => ({
  warnings: [],
  importedInvoice: {
    taxInformation: {
      nfe: {},
    },
    linkedDocuments: {
      linkedDocumentCollection: [],
    },
    supplier: {
      identification: null,
      address: {
        zipCode: {
          city: {
            state: {},
          },
        },
      },
    },
    products: {
      productOfPurchaseCollection: [],
    },
    transport: {
      shippingCompany: {},
    },
    taxCalc: {
      vBC: 0,
      vBCST: 0,
      vCOFINS: 0,
      vICMS: 0,
      vICMSDeson: 0,
      vIPI: 0,
      vPIS: 0,
      vICMSST: 0,
      vFCP: 0,
      vFCPST: 0,
      vFCPSTRet: 0,
      vDesc: 0,
      vFrete: 0,
      vSeg: 0,
      vTotTrib: 0,
      vOutro: 0,
      vProd: 0,
      vNF: 0,
    },
  },
});

const defaultTransportState = () => ({
  transport: {
    shippingCompany: [],
    freight: null,
    vehicle: [],
    vehicleCollection: [],
    addressCollection: [],
    address: [],
    volume: {
      species: null,
      brand: null,
      amountVolume: null,
      netWeight: null,
      grossWeight: null,
      numeration: null,
    },
  },
});

const defaultPurchaseParams = () => ({
  purchaseParams: {
    decimalConfiguration: {
      price: null,
      quantity: null,
    },
  },
});

export const taxInformation = defaultTaxInformationState();
export const linkedDocuments = defaultLinkedDocumentsState();
export const supplierInformation = defaultSupplierState();
export const products = defaultProductsState();
export const taxCalc = defaultTaxCalcState();
export const transport = defaultTransportState();
export const payments = defaultPaymentsState();
export const productOfPurchaseOnFiscalEdit = defaultProductOfPurchaseOnFiscalEditState();
export const importedInvoice = defaultImportedInvoiceState();
export const purchaseParams = defaultPurchaseParams();

export const defaultState = () => ({
  nfeCollection: [],
  purchaseCollection: [],
  summaryPurchases: [],
  selectedNatureza: {},
  importedInvoiceFormData: null,
  paginationPurchase: {
    perPage: 15,
    currentPage: 1,
  },
  purchase: {
    id: null,
    isEditing: false,
    ...taxInformation,
    ...linkedDocuments,
    ...supplierInformation,
    ...products,
    ...transport,
    ...taxCalc,
    ...payments,
    observation: null,
  },
  ...productOfPurchaseOnFiscalEdit,
  ...importedInvoice,
  ...purchaseParams,
  loadingTab: false,
  unitOfMeasure: 'UN',
  cfopCollection: [],
  matchedCfopForProductPurchase: null,
});

export const stateToReset = () => ({
  nfeCollection: [],
  purchaseCollection: [],
  summaryPurchases: [],
  importedInvoiceFormData: null,
  paginationPurchase: {
    perPage: 15,
    currentPage: 1,
  },
  purchase: {
    id: null,
    isEditing: false,
    ...defaultTaxInformationState(),
    ...defaultLinkedDocumentsState(),
    ...defaultSupplierState(),
    ...defaultProductsState(),
    ...defaultTransportState(),
    ...defaultTaxCalcState(),
    ...defaultPaymentsState(),
    observation: null,
  },
  ...defaultProductOfPurchaseOnFiscalEditState(),
  ...defaultImportedInvoiceState(),
  ...defaultPurchaseParams(),
  loadingTab: false,
  cfopCollection: [],
  matchedCfopForProductPurchase: null,
});

export const initialState = defaultState();

export default {
  ...initialState,
  ...taxInformation,
  ...linkedDocuments,
  ...supplierInformation,
  ...products,
  ...productOfPurchaseOnFiscalEdit,
  ...transport,
  ...taxCalc,
  ...payments,
  ...purchaseParams,
};
